import React, { Fragment } from "react";

const QuizList = ({ data }) => {

  return (
    <div className="mb-4">
      <h2>Quizes</h2>
      <div className="view-card-table table mb-0 pt-2">
        <table className="table border mb-0 border-top-0">
          <thead className="heading">
            <tr className="hdng-row border-bottom-0">
              <th className="text-start px-3">Quiz name</th>
              <th className="text-center px-3">Attempts</th>
              <th className="text-center px-3">Score</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              return (<tr kye={index}>
                <td className="text-start">{item?.quizName}</td>
                <td className="text-center">{item?.attempts}</td>
                <td className="text-center">{Math.ceil(item?.score)}</td>
              </tr>)
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuizList;
